// @flow
import { RESORT_TRIPADVISOR } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_TRIPADVISOR } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

type CMSProps = {|
  awards: string,
  basedOn: string,
  reviews: string,
  ratingTitle: string,
  ratings: string,
  reviews: string,
  resortId: string,
  tripAdvisorLineTitle: string,
  tripAdvisorViewMoreLabel: string,
|};

export const productTripadvisorResolver = {
  name: RESORT_TRIPADVISOR,
  resolve(appContext: AppContext = {}, props: CMSProps) {
    const { cmsContent, cmsRelease } = appContext;
    const cmsArgs = `content: "${cmsContent}", release:"${cmsRelease}"`;

    const query = `query {
      config {
        common { next previous }
      }
      tripadvisor(resortId:"${props.resortId}") {
        awards {
          displayName
          images {
            large
          }
        }
        numReviews
        rating
        ratingImageUrl
        reviews {
          title
          text
          url
          rating
          ratingImageUrl
          reviewAuthor(${cmsArgs})
          publishedDate
          reviewDate(${cmsArgs})
        }
        subratings {
          localizedName
          ratingImageUrl
          value
        }
        tripAdvisorUrl
      },
    }`;

    return graphQLClient
      .runQuery(query, appContext, { requestName: LINE_PRODUCT_TRIPADVISOR, strictErrors: false })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      })
      .catch(() => ({}));
  },
};
